export const MenuList = [
    {
        title: 'Tasks',
        menu_key: 'tasks',
        classsChange: 'mm-collapse',
        iconStyle: <i className="fas fa-tasks"></i>,
        content: [
            {
                title: 'Task',
                menu_key: 'task_list',
                to: '/task/tasklist'
            },
            {
                title: 'Performance Report',
                to: '/task/performance',
                publicAccess: true,
            },
            {
                title: 'Worksheet',
                menu_key: 'worksheet',
                to: '/task/worksheet',
                role: 'admin', // All admin roles (including sub_department_admin) can access
                feature_key: 'worksheet'
            },
            {
                title: 'Work Register',
                menu_key: 'work_register',
                to: '/work-register/list',
            },
            {
                title: 'Team Work Register',
                menu_key: 'work_register_team',
                to: '/work-register/team',
            },
            {
                title: 'Project ',
                menu_key: 'project',
                to: '/task/projectlist',
                feature_key: 'project'
            }
        ],
    },
    {
        title: 'Discussion Forum',
        menu_key: 'forum',
        classsChange: 'mm-collapse',
        iconStyle: <i className="fas fa-comments"></i>,
        content: [
            {
                title: 'Forums',
                menu_key: 'forum_list',
                to: '/forum/list',
            },
            {
                title: 'Start Conversation',
                menu_key: 'forum_create',
                to: '/forum/create',
            },
        ],
    },
    {
        title: 'Snap Bill',
        menu_key: 'invoice_scanner',
        classsChange: 'mm-collapse',
        iconStyle: <i className="fas fa-file-invoice"></i>,
        content: [
            {
                title: 'Open Snap Bill',
                menu_key: 'invoice_scanner_access',
                to: '/invoice-scanner/launch',
                feature_key: 'invoice_scanner',
            },
        ],
    },
    {
        title: 'Documents',
        menu_key: 'documents',
        classsChange: 'mm-collapse',
        iconStyle: <i className="fas fa-file-alt"></i>,
        content: [
            {
                title: 'Dashboard',
                menu_key: 'doc_dashboard',
                to: '/documents/dashboard'
            },
            {
                title: 'My Documents',
                menu_key: 'doc_my_documents',
                to: '/documents/mydocuments'
            },
            {
                title: 'Shared Documents',
                menu_key: 'doc_shared',
                to: '/documents/shared'
            },
            {
                title: 'Favorite Documents',
                menu_key: 'doc_favorites',
                to: '/documents/favorites'
            },
            {
                title: 'Classifications',
                menu_key: 'doc_classifications',
                to: '/documents/documentClassifications'
            },
        ],
    },
    {
        title: 'Credentials Vault',
        /** When true, keep parent as expand/collapse (show sub-items) instead of merging into one direct link. */
        alwaysShowSubmenu: true,
        classsChange: 'mm-collapse',
        iconStyle: <i className="fas fa-key"></i>,
        content: [
            {
                title: 'Corporate Credentials',
                menu_key: 'credential_vault_list',
                to: '/credential-vault/credentialVaultList',
            },
            {
                title: 'Personal Credentials',
                menu_key: 'credential_vault_list',
                to: '/credential-vault/personalVaultList',
            },
        ],
    },
    {
        title: 'Settings',
        menu_key: 'settings',
        classsChange: 'mm-collapse',
        iconStyle: <i className="fas fa-cog"></i>,
        content: [
            {
                title: 'Users',
                menu_key: 'settings_users',
                role: 'admin', // All admin roles can access users
                to: 'settings/userlist'
            },
            {
                title: 'Staff',
                menu_key: 'settings_staff',
                role: 'corporate_admin', // Only corporate admin can access
                to: 'staff/staffList'
            },
            {
                title: 'Access Control',
                menu_key: 'settings_access_control',
                role: 'corporate_admin',
                to: 'settings/accessControl'
            },
            {
                title: 'Branches',
                menu_key: 'settings_branches',
                role: 'corporate_admin', // Only corporate admin can access
                to: 'settings/branchList',
                feature_key: 'branch'
            },
            {
                title: 'Departments',
                menu_key: 'settings_departments',
                role: 'admin', // Corporate and branch admin can access
                restricted_roles: ['department_admin', 'sub_department_admin'], // Department and sub department admin cannot access
                to: 'settings/departmentList',
                feature_key: 'department'
            },
            {
                title: 'Sub Departments',
                menu_key: 'settings_sub_departments',
                role: 'admin', // Corporate, branch, and department admin can access
                restricted_roles: ['sub_department_admin'], // Sub department admin cannot access
                to: 'settings/subDepartmentList',
                feature_key: 'department'
            },
            {
                title: 'Designations',
                menu_key: 'settings_designations',
                role: 'corporate_admin', // Only corporate admin can access
                to: 'settings/designationList',
                feature_key: 'department'
            },
            {
                title: 'Vehicle',
                menu_key: 'settings_vehicle',
                role: 'corporate_admin', // Only corporate admin can access
                to: '/vehicle/vehicleList'
            },
            {
                title: 'Credentials Vault',
                menu_key: 'credential_vault_settings',
                to: '/credential-vault/vaultSettings',
            },
        ],
    },
]